import React from 'react';
import Table from '../../components/Table/Table';
import { TableColumn } from '../../types';
import { CrewMemberView } from './vesselReportTypes';

interface VesselCrewListViewProps {
  vesselName: string;
  listType: 'signed-on' | 'on-vacation';
  crewData: CrewMemberView[];
  onBack: () => void;
}

const crewColumns: TableColumn[] = [
  {
    key: 'name',
    label: 'Crew Member',
    sortable: true,
    render: (value: string, item: CrewMemberView) => (
      <div>
        <div className="font-medium text-gray-900">{value}</div>
        <div className="text-sm text-gray-500">{item.rank}</div>
      </div>
    )
  },
  { key: 'nationalId', label: 'National ID', sortable: true },
  { key: 'phone', label: 'Phone', sortable: false },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    render: (value: string) => {
      const statusColors: Record<string, string> = {
        'signed-on': 'bg-green-100 text-green-800',
        'on-vacation': 'bg-blue-100 text-blue-800',
        'signed-off': 'bg-gray-100 text-gray-800'
      };
      return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusColors[value] || 'bg-gray-100 text-gray-800'}`}>
          {value.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase())}
        </span>
      );
    }
  },
  {
    key: 'signOnDate',
    label: 'Sign On / Sign Off Date',
    render: (_value: string, item: CrewMemberView) => {
      if (item.status === 'signed-on' && item.signOnDate) {
        return (
          <div className="text-sm">
            <span className="text-gray-600">Sign On:</span> {new Date(item.signOnDate).toLocaleDateString()}
          </div>
        );
      } else if ((item.status === 'on-vacation' || item.status === 'signed-off') && item.signOffDate) {
        return (
          <div className="text-sm">
            <span className="text-gray-600">Sign Off:</span> {new Date(item.signOffDate).toLocaleDateString()}
          </div>
        );
      }
      return 'N/A';
    }
  }
];

const VesselCrewListView: React.FC<VesselCrewListViewProps> = ({
  vesselName, listType, crewData, onBack,
}) => (
  <div className="card">
    <div className="p-6 border-b border-gray-200">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-medium text-gray-900">
            {vesselName} - {listType === 'signed-on' ? 'Signed On Crew' : 'Crew On Vacation'}
          </h2>
          <p className="text-sm text-gray-600">
            Showing {crewData.length} crew member{crewData.length !== 1 ? 's' : ''}
          </p>
        </div>
        <button
          onClick={onBack}
          className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
        >
          Back to Vessel Report
        </button>
      </div>
    </div>
    <Table data={crewData} columns={crewColumns} searchable={true} />
  </div>
);

export default VesselCrewListView;
